'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ArrowIcon = require('dibs-vg/dist/react/arrow-right');

const ProfileLink = ({ image, caption, url, label }) => (
    <div className="pdp-hero-link">
        {image ? <img className="pdp-hero-link-image" src={image} alt={caption} /> : null}
        <div className="pdp-hero-link-content">
            {caption ? <div className="pdp-hero-link-caption">{caption}</div> : null}
            <a href={url}>
                {label} <ArrowIcon className="pdp-hero-link-arrow" />
            </a>
        </div>
    </div>
);

ProfileLink.propTypes = {
    image: PropTypes.string,
    caption: PropTypes.string,
    url: PropTypes.string.isRequired,
    label: PropTypes.string,
};

ProfileLink.defaultProps = {
    label: 'View Profile',
};

module.exports = ProfileLink;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ProfileLink/ProfileLink.jsx